import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps } from 'react-router'
import AddTime from './Time/AddTime'
import EditTime from './Time/EditTime'
import BaseTimeOverview from '../v2/pages/Time/TimeOverview'
import GlobalTimeOverview from '../v2/pages/Time/GlobalTimeOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'
import GlobalTimeSuggestionOverview from './Time/GlobalTimeSuggestionOverview'
import TimeSuggestionOverview from './Time/TimeSuggestionOverview'

export const timeBaseUrl = '/time'

export default function Times(props: EntityPageProps): ReactElement {
    return (
        <EntityPage {...props} baseUrl={timeBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <>
                    <Route
                        exact
                        path={route}
                        render={(routeProps: RouteComponentProps) =>
                            props.currentFile === undefined ? (
                                <GlobalTimeOverview baseUrl={baseUrl} />
                            ) : (
                                <BaseTimeOverview
                                    {...routeProps}
                                    {...props}
                                    fileId={props.currentFile?.id}
                                    baseUrl={baseUrl}
                                    localStorageKeyPrefix={`HammockTimeOverview-${props.currentFile.id}-`}
                                />
                            )
                        }
                    />
                    <Route
                        path={`${route}/suggestion`}
                        render={(routeProps: RouteComponentProps) =>
                            props.currentFile === undefined ? (
                                <GlobalTimeSuggestionOverview baseUrl={baseUrl} />
                            ) : (
                                <TimeSuggestionOverview
                                    {...routeProps}
                                    {...props}
                                    fileId={props.currentFile?.id}
                                    baseUrl={baseUrl}
                                    localStorageKeyPrefix={`HammockTimeSuggestionOverview-${props.currentFile.id}-`}
                                />
                            )
                        }
                    />
                    <Route path={`${route}/add`}>
                        <AddTime returnUrl={baseUrl} currentFile={props.currentFile} />
                    </Route>
                    <Route path={`${route}/:id/edit`}>
                        <EditTime returnUrl={baseUrl} currentFile={props.currentFile} />
                    </Route>
                </>
            )}
        </EntityPage>
    )
}
